<template>
  <div>
    <AppMain></AppMain>
  </div>
</template>

<script>
import { AppMain } from "./components";
export default {
  name: "Layout",
  components: {
    AppMain,
  },
};
</script>

<style lang="scss" scoped>
div {
  background: #fff;
}
</style>
